export default __webpack_public_path__ + "static/media/i.eb4b8378.svg";